import { render, staticRenderFns } from "./FIBTitle.vue?vue&type=template&id=3f65936d&scoped=true&"
import script from "./FIBTitle.vue?vue&type=script&lang=js&"
export * from "./FIBTitle.vue?vue&type=script&lang=js&"
import style0 from "./FIBTitle.vue?vue&type=style&index=0&id=3f65936d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65936d",
  null
  
)

export default component.exports